import { render } from "./DisclaimerPanel.vue?vue&type=template&id=33f99a40"
import script from "./DisclaimerPanel.vue?vue&type=script&lang=js"
export * from "./DisclaimerPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__